// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"97":"cde74b75","205":"f7bab6cb","234":"74f70328","254":"ac3875de","440":"1ba8ab19","445":"54ce69b0","607":"9a02f01e","633":"c03d680f","674":"79c21106","680":"15ce3173","710":"31b96dc1","738":"074f9580"}[chunkId] + ".js";
};